// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmActionDialog {
}
.confirmActionDialog__title {
    font-size: 1.5rem;
}
.confirmActionDialog__content {
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
}
.confirmActionDialog__content__assure {
    font-size: 1.2rem;
}
.confirmActionDialog__content__mutation {
    margin-left: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/confirmActionDialog/ConfirmActionDialog.css"],"names":[],"mappings":"AAAA;AACA;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".confirmActionDialog {\n}\n.confirmActionDialog__title {\n    font-size: 1.5rem;\n}\n.confirmActionDialog__content {\n    gap: 0.5rem;\n    display: flex;\n    flex-direction: column;\n}\n.confirmActionDialog__content__assure {\n    font-size: 1.2rem;\n}\n.confirmActionDialog__content__mutation {\n    margin-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
